import React from "react";
import blob from '../assets/blob.webp'
import blr1 from "../assets/blurs01.svg"
import blr2 from "../assets/blurs02.svg"
import Social from "../components/Social";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import {motion, AnimatePresence } from "framer-motion";
import {useEffect} from 'react';
import Cursor from "../components/CursorBall"

const Home = () => {

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return(
        <div>
        <Cursor/>
        <motion.button
            whileHover={{scale:1.1, color:'white', backgroundColor:'transparent', transition:{duration:1}}}
            whileTap={{scale:0.8, color:'white', backgroundColor:'transparent'}}
            className="p-4 toppp fixed text-xl bottom-[40px] right-[40px]  text-black text-center rounded-full bg-white"
            onClick={() => {
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});}}>
        ↑</motion.button>
            <Header/>
            <AnimatePresence>
                <motion.div 
                key="hom"
                initial={{opacity:0}}
                animate={{opacity:1}}
                exit={{opacity:0, transition:{duration:5}}}
                transition={{duration:1, ease:"easeInOut"}}>
                    <div>
                        <Helmet>
                            <title>Hari Prasad • Creative Designer & Front-End Dev </title>
                            <meta
                            name="description"
                            content="Creating Experiences for Myself & Designing Experiences for Products"
                            />
                            <meta
                            name="keywords"
                            content="design, uiux, code, creative, frontend, dev, brand"
                            />
                        </Helmet>
                        
                        <div className="-mt-[4.1rem] md:-mt-[8.1rem]">
                            <div className="pc flex text-slate-300 text-md font-light flex-row gap-10 justify-end p-5 m-6 mx-8">
                                <Link to = "/"><h2 className="font-normal text-white"><abbr title="About me in short">ABOUT</abbr>
                                            <div className="hr"></div></h2></Link>
                                <Link to ="/projects"><h2 className="hover:text-white"><abbr title="List of projects, I've worked on">PROJECTS</abbr></h2></Link>
                                <Link to ="/random"><h2 className="hover:text-white"><abbr title="ever seen a 404 page in Navbar?">404 😜</abbr></h2></Link>
                            </div>
                            <div className="mob flex items-center text-slate-400 font-light flex-row gap-4 justify-start mx-10 mb-9 ">
                                <h2 className="text-sm"><br></br> <p className="text-lg font-normal text-white">ABOUT</p><div className="hr"/></h2>
                                <p>•</p>
                                <h2 className="text-sm"><Link to ="/projects" className="text-lg font-normal text-slate-300">PROJECTS</Link></h2>
                            </div>

                            <section>
                                <motion.div className="gap-2 md:gap-12 text-white flex flex-row justify-center   items-center p-5 m-4">

                                    <motion.div
                                    initial={{ y:0 }}
                                    animate={{ y:[-5, 5,-5]}}
                                    transition={{ repeatType:"loop",ease:"linear", type:"tween", repeat: Infinity, duration:5 }}>
                                    <img className="w-[23rem] scaleup pc" src={blob} alt="about blob" ></img>
                                    </motion.div>

                                    <div className="flex flex-col gap-7 ">
                                        <div className="-mx-5 md:p-2 -mx-0">
                                            <p className="text-xs font-thin text-slate-300">#OpenToWork</p>
                                            <motion.h1
                                            initial={{ opacity:0, x:-10}}
                                            animate={{opacity:1, x:0}}
                                            transition={{ duration: 0.7 }}
                                            className="text-3xl pt-1 font-semibold">Designer & Developer
                                            </motion.h1>
                                            <div className="md: leading-6 text-sm font-light pt-5 text-slate-300">
                                                <p>• CSE Undergrad 2023 <br></br>
                                                • Designed <a href="https://incus.online/" className="text-white"><b>@Incus.inc</b></a><br></br>	
                                                • Developed Frontend for College & Commercial projects </p><br></br>
                                                <p>Founder & Designer <a className="text-white" rel="noreferrer" href="https://devignx.vercel.app"><b>@DevignX</b></a></p>
                                            </div>
                                        </div>
                                        <div className="flex gap-4">
                                            <motion.a whileTap={{ scale: 0.9 }} target="_blank" rel="noreferrer" href="https://drive.google.com/file/d/1wqLiEmBD8CkBseNNqc7c00-WbuliD4-V/view"><button className="bg-white text-xs w-min rounded-full text-black px-8 py-4"><motion.p
                                            whileTap={{scale:1.2}}>RESUME</motion.p></button></motion.a>
                                            <motion.a whileTap={{ scale: 0.9 }} target="_blank" rel="noreferrer" href="https://github.com/hariprasd/hariprasd/blob/main/coverletter.md"><button className="bg-transparent text-xs border-solid border-2 border-white/20 w-fit rounded-full text-white px-8 py-4 hover:bg-white/[0.02]"><motion.p
                                            whileTap={{scale:1.2}}>LEARN MORE</motion.p></button></motion.a>
                                        </div>
                                    </div>
                                    
                                </motion.div> 
                                
                            </section>               
            
                        </div>
                    </div>
                    <Social/>

                </motion.div>
            </AnimatePresence>

            <div className="pointer-events-none">
                    <img className="fixed bottom-[30%] -left-40 md:-left-40 w-[50rem] blur-lg -z-[999]" src={blr2} rel="preload" alt='blur'></img>
                    <img className="fixed -bottom-[0%] -right-40 md:-right-20 -bottom-[20%] w-[50rem] blur-lg -z-[999] " src={blr1} rel="preload" alt='blur'></img>
            </div>
        </div>
    )
}

export default Home;
